import { render, staticRenderFns } from "./amazonModal.vue?vue&type=template&id=63731020&scoped=true"
import script from "./amazonModal.vue?vue&type=script&lang=js"
export * from "./amazonModal.vue?vue&type=script&lang=js"
import style0 from "./amazonModal.vue?vue&type=style&index=0&id=63731020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63731020",
  null
  
)

export default component.exports